module.exports = __webpack_public_path__ + "media/images/logo-nita-0c29a12bb57d3417169ea526cc95e07f.png";